import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import { Box, Typography, Card, CardMedia, InputBase, IconButton } from "@mui/material";
import { RocketLaunch, Search } from "@mui/icons-material";
import VideoPlayerModalHotstar from "./VideoPlayerModalHotstar";

const abc = [
  {
    "episodeTitle": "Ep 1 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false,
    "isVideoWatched": true
  },
  {
    "episodeTitle": "Ep 2 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false,
    "isVideoWatched": true
  },
  {
    "episodeTitle": "Ep 3 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 4 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 5 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 6 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 7 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": false
  },
  {
    "episodeTitle": "Ep 8 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 9 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 10 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 11 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 12 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 13 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 14 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 15 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 16 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 17 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 18 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 19 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 20 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 21 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 22 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 23 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 24 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 25 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 26 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 27 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 28 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 29 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 30 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 31 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 32 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 33 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 34 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 35 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 36 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 37 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 38 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 39 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 40 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 41 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 42 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 43 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 44 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 45 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 46 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 47 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 48 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 49 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 50 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 51 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 52 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 53 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 54 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 55 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 56 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 57 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 58 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 59 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 60 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 61 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 62 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 63 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 64 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 65 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 66 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 67 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 68 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 69 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 70 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 71 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 72 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 73 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 74 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 75 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 76 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 77 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 78 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 79 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 80 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 81 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 82 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 83 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 84 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 85 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 86 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 87 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 88 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 89 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 90 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 91 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 92 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 93 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240402/197999/8f98a8c5a3234cd98e29eeb5a2cb5eba.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 94 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 95 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240216/197999/c380d491f7d5420ca423bd4005d77c44.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 96 - Sample Episode",
    "video": "https://goqii-pub.goqii.com/upload/shorts/20240326/197999/1458e82be36b4d0a8a3986d81e2a703e.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 97 - Sample Episode",
    "video": "https://www.w3schools.com/html/mov_bbb.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 98 - Sample Episode",
    "video": "https://www.w3schools.com/html/movie.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 99 - Sample Episode",
    "video": "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  },
  {
    "episodeTitle": "Ep 100 - Sample Episode",
    "video": "https://filesamples.com/samples/video/mp4/sample_640x360.mp4",
    "thumbnail": "https://www.w3schools.com/w3images/nature.jpg",
    "locked": true
  }
];
const dummyData = {
  searchPlaceholder: "Search for exciting videos...",
  carousel: [
    {
      title: "Reimagine Health Talk",
      image: "https://appcdn.goqii.com/storeimg/usercon/rdm38344/36232_1544061429.jpg",
      video: "https://www.w3schools.com/html/mov_bbb.mp4",
      episodes: abc
    },
    {
      title: "GOQii Shorts",
      image: "https://appcdn.goqii.com/storeimg/usercon/rdm46594/58975_1708682905.jpeg",
      video: "https://www.w3schools.com/html/mov_bbb.mp4",
      episodes: abc
    },


  ],
  trending: {
    title: "Most Trending",
    items: [
      {
        title: "",
        image: "https://appcdn.goqii.com/storeimg/usercon/rdm33176/o_77832_1664437282.png",
        video: "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
        episodes: abc
      },
      {
        title: "",
        image: "https://appcdn.goqii.com/storeimg/41332_1592999332.png",
        video: "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
        episodes: abc
      },

    ],
  },
  newRelease: {
    title: "New Releases",
    items: [
      {
        title: "",
        image: "https://goqii-app.s3.amazonaws.com/emailer/36563_1543831156.png",
        video: "https://www.w3schools.com/html/movie.mp4",
        episodes: abc

      },
    ],
  },
  comingSoon: {
    title: "Coming Soon",
    items: [
      {
        title: "",
        image: "https://goqii-app.s3.amazonaws.com/emailer/55365_1543831008.png",
        video: "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4",
        episodes: abc
      },
    ],
  },
};


const Home = () => {

  // const [visibleEpisodes, setVisibleEpisodes] = useState(5);
  const { searchPlaceholder, carousel } = dummyData;
  const [open, setOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedEpisodes, setSelectedEpisodes] = useState([]);
  const episodesRef = useRef(null);
  const handlePlayVideo = (videoUrl, episodes = []) => {
    setSelectedVideo(videoUrl);
    setSelectedEpisodes(episodes);
    setOpen(true);
    console.log("Total Episodes:", episodes.length, episodes);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <Box sx={{ backgroundColor: "#000", color: "#fff", minHeight: "100vh", padding: "16px" }}>
      {/* Search Bar */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <Box sx={{ backgroundColor: "#222", borderRadius: "24px", padding: "8px 16px", display: "flex", alignItems: "center", width: "100%", maxWidth: "400px" }}>
          <Search sx={{ color: "#999", marginRight: "8px" }} />
          <InputBase sx={{ color: "#fff", flex: 1 }} placeholder={searchPlaceholder} />
        </Box>
      </Box>

      {/* Carousel */}
      <Box mb={4}>
        <Slider {...settings}>
          {carousel.map((item, index) => (
            <Card key={index} onClick={() => handlePlayVideo(item.video, item.episodes)} sx={{ position: "relative", borderRadius: "16px", overflow: "hidden", cursor: "pointer" }}>
              <CardMedia component="img" height="300" image={item.image} alt={item.title} />
              <Box sx={{ position: "absolute", bottom: "16px", left: "16px", color: "#fff" }}>
                <Typography variant="h6" fontWeight="bold">{item.title}</Typography>
              </Box>
            </Card>
          ))}
        </Slider>
      </Box>

      {/* Sections */}
      {[dummyData.trending, dummyData.newRelease, dummyData.comingSoon].map((section, index) =>
        section && section.items ? (
          <Box key={index} mb={4}>
            <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mb: 2, fontWeight: "bold" }}>
              <RocketLaunch sx={{ marginRight: 1 }} />
              {section.title}
            </Typography>
            <Box display="flex" gap="16px" overflow="auto">
              {section.items.map((item, idx) => (
                <Card key={idx} onClick={() => handlePlayVideo(item.video, item.episodes)} sx={{ minWidth: "120px", backgroundColor: "#222", borderRadius: "8px", overflow: "hidden", cursor: "pointer" }}>
                  <CardMedia component="img" height="160" image={item.image} alt={item.title} />
                  <Typography sx={{ padding: "8px", textAlign: "center", fontSize: "14px", fontWeight: "500", color: "#fff" }}>{item.title}</Typography>
                </Card>
              ))}
            </Box>
          </Box>
        ) : null
      )}

      {/* Video Modal with Swipe Up to Load More Episodes */}
      <VideoPlayerModalHotstar
        open={open}
        handleClose={handleClose}
        selectedVideo={selectedVideo}
        selectedEpisodes={selectedEpisodes}
        setSelectedVideo={setSelectedVideo}
        episodesRef={episodesRef}
      />
    </Box>
  );
};


export default Home;